// @flow
import { Component } from 'react';
import mapboxgl from 'mapbox-gl';

// import styles from './draggablemarker.css';

const DRAGGABLE_MARKER_SOURCE_ID = 'draggableMarkerSource';
const DRAGGABLE_MARKER_LAYER_ID = 'draggableMarkerLayer';

type DraggableMarkerPropTypes = {
  map: mapboxgl.Map,
  latitude: number,
  longitude: number,
  isPlaced: boolean,
  onDragStart?: Function,
  onDragEnd?: Function,
};

type DraggableMarkerStateTypes = {
  isDragging: boolean,
  isCursorOverPoint: boolean
};

const buildGeoJSON = (latitude: number, longitude: number) => ({
  type: 'FeatureCollection',
  features: [{
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [longitude, latitude],
    },
  }],
});

class DraggableMarker extends Component<DraggableMarkerPropTypes, DraggableMarkerStateTypes> {
  constructor(props: DraggableMarkerPropTypes) {
    super(props);
    this.state = {
      isDragging: false,
      isCursorOverPoint: false,
    };
  }

  componentDidMount() {
    const {
      map,
      latitude,
      longitude,
      isPlaced,
    } = this.props;
    const geoJSON = buildGeoJSON(latitude, longitude);

    // Add Draggable Marker layer
    try {
      map.addSource(DRAGGABLE_MARKER_SOURCE_ID, {
        type: 'geojson',
        data: geoJSON,
      });
    } catch (_e) {
      /* noop if there is already that source */
    }

    return isPlaced && this._addMarker();
  }

  componentWillReceiveProps(nextProps: DraggableMarkerPropTypes) {
    const {
      latitude,
      longitude,
      isPlaced,
      map,
    } = this.props;

    // Remove
    if (isPlaced && !nextProps.isPlaced) {
      this._removeMarker();

    // Place
    } else if (!isPlaced && nextProps.isPlaced) {
      this._addMarker();
    }

    // Move
    const nextLatitude = nextProps.latitude;
    const nextLongitude = nextProps.longitude;
    if (latitude !== nextLatitude || longitude !== nextLongitude) {
      map.getSource(DRAGGABLE_MARKER_SOURCE_ID).setData(
        buildGeoJSON(nextLatitude, nextLongitude),
      );
    }
  }

  componentWillUnmount() {
    this._removeMarker();
  }

  _onMouseDown(e: { lngLat: { lat: number, lng: number } }) {
    const { isCursorOverPoint } = this.state;
    const { map, onDragStart } = this.props;
    const canvas = map.getCanvasContainer();

    if (!isCursorOverPoint) return;

    this.setState({ isDragging: true });

    // Callback
    if (onDragStart) {
      onDragStart(e.lngLat.lng, e.lngLat.lat);
    }

    // Set a cursor indicator
    canvas.style.cursor = 'grab';

    // Mouse events
    map.on('mousemove', this._onMouseMove.bind(this));
    map.on('mouseup', this._onMouseUp.bind(this));
  }

  _onMouseMove(e: { lngLat: { lat: number, lng: number } }) {
    const { isDragging } = this.state;
    const { map } = this.props;

    if (!isDragging) return;

    map.getSource(DRAGGABLE_MARKER_SOURCE_ID).setData(
      buildGeoJSON(e.lngLat.lat, e.lngLat.lng),
    );
  }

  _onMouseUp(e: Object) {
    const { isDragging } = this.state;
    const { map, onDragEnd } = this.props;
    const canvas = map.getCanvasContainer();

    if (!isDragging) return;

    canvas.style.cursor = '';
    this.setState({ isDragging: false });

    // Callback
    if (onDragEnd) {
      onDragEnd(e.lngLat.lng, e.lngLat.lat);
    }

    // Unbind mouse events
    map.off('mousemove', this._onMouseMove.bind(this));
  }

  _onMouseEnter() {
    const { map } = this.props;
    const canvas = map.getCanvasContainer();

    canvas.style.cursor = 'move';
    map.dragPan.disable();

    this.setState({
      isCursorOverPoint: true,
    });
  }

  _onMouseLeave() {
    const { map } = this.props;
    const canvas = map.getCanvasContainer();
    canvas.style.cursor = '';
    map.dragPan.enable();

    this.setState({
      isCursorOverPoint: false,
    });
  }

  _addMarker() {
    const { map } = this.props;

    if (!map.hasImage('goalMarker')) {
      map.loadImage('/assets/images/goalMarker.png', (_error, image) => {
        map.addImage('goalMarker', image);
        map.addLayer({
          id: DRAGGABLE_MARKER_LAYER_ID,
          type: 'symbol',
          source: DRAGGABLE_MARKER_SOURCE_ID,
          layout: {
            'icon-image': 'goalMarker',
            'icon-size': 0.45,
          },
        });
      });
    } else {
      map.addLayer({
        id: DRAGGABLE_MARKER_LAYER_ID,
        type: 'symbol',
        source: DRAGGABLE_MARKER_SOURCE_ID,
        layout: {
          'icon-image': 'goalMarker',
          'icon-size': 0.45,
        },
      });
    }

    map.on('mouseenter', DRAGGABLE_MARKER_LAYER_ID, this._onMouseEnter.bind(this));
    map.on('mouseleave', DRAGGABLE_MARKER_LAYER_ID, this._onMouseLeave.bind(this));
    map.on('mousedown', DRAGGABLE_MARKER_LAYER_ID, this._onMouseDown.bind(this));
  }

  _removeMarker() {
    const { map } = this.props;
    map.off('mouseenter', DRAGGABLE_MARKER_LAYER_ID, this._onMouseEnter.bind(this));
    map.off('mouseleave', DRAGGABLE_MARKER_LAYER_ID, this._onMouseLeave.bind(this));
    map.off('mousedown', DRAGGABLE_MARKER_LAYER_ID, this._onMouseDown.bind(this));
    map.removeLayer(DRAGGABLE_MARKER_LAYER_ID);
    map.removeSource(DRAGGABLE_MARKER_SOURCE_ID);
  }

  render() { return null; }
}

export default DraggableMarker;



// WEBPACK FOOTER //
// ./src/scripts/components/DraggableMarker/index.jsx